import { useFetch } from "hooks/api";
import { useAppSelector } from "redux/hooks";
import { useModuleEnabled } from "redux/selectors/modules";

export const useAMCInstanceDataSouces = () => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const hasAMCModule = useModuleEnabled("AMC");

  const { data, isLoading } = useFetch(
    ["allowAMCDataSources"],
    "/amc/datasources",
    {
      marketplace: marketPlace,
    },
    {
      select: (res) => {
        return res.data ?? [];
      },
      enabled: hasAMCModule,
      default: [],
    },
  );

  return { data, isLoading };
};
